<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">{{ $t('customer.cards.title') }}</h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <table class="emd-table">
          <thead>
            <tr>
              <th>{{ $t('customer.cards.id') }}</th>
              <th>{{ $t('customer.cards.name') }}</th>
              <th>{{ $t('customer.cards.status') }}</th>
              <th>{{ $t('customer.cards.billing-address') }}</th>
              <th>{{ $t('customer.cards.type') }}</th>
              <th>{{ $t('customer.cards.expires') }}</th>
              <th>{{ $t('customer.cards.number') }}</th>
              <th>{{ $t('customer.cards.brand') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(card, index) in cards.items"
              :key="index"
            >
              <td :data-label="$t('customer.cards.id')">
                {{ card.id || '-' }}
              </td>
              <td :data-label="$t('customer.cards.name')">
                {{ card.holder_name || '-' }}
              </td>
              <td :data-label="$t('customer.cards.status')">
                <span
                  class="emd-badge"
                  v-bind:class="statusClass(card.status)"
                  >{{ card.status }}</span
                >
              </td>
              <td :data-label="$t('customer.cards.billing-address')">
                <span
v-if="card.billing_address"
                  >{{ card.billing_address.street }},
                  {{ card.billing_address.number }} -
                  {{ card.billing_address.neighborhood }} -
                  {{ card.billing_address.city }} -
                  {{ card.billing_address.state }}</span
                >
                <span v-else>-</span>
              </td>
              <td :data-label="$t('customer.cards.type')">{{ card.type }}</td>
              <td :data-label="$t('customer.cards.type')">
                {{ card.exp_month }}/{{ card.exp_year }}
              </td>
              <td
                class="fs-hide"
                :data-label="$t('customer.cards.number')"
              >
                {{ card.first_six_digits }}** **{{ card.last_four_digits }}
              </td>
              <td :data-label="$t('customer.cards.brand')">{{ card.brand }}</td>
            </tr>
          </tbody>
        </table>
        <empty-list v-if="!loadingList && showEmptyList()"></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="cards.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
        :entity="'customerId'"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import { statusClass } from '@/filters'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerCards',
  components: {
    EmdLoader,
    EmptyList,
    Pagination
  },
  data () {
    return {
      action: 'GET_CUSTOMER_CARDS',
      statusClass: statusClass
    }
  },
  computed: {
    ...mapGetters([
      'merchant',
      'account',
      'customersCards',
      'loadingCustomersCard'
    ]),
    cards () {
      return this.customersCards
    },
    totalItems () {
      return this.cards.items.length
    },
    loadingList () {
      return this.loadingCustomersCard
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.cards.pagination &&
        this.cards.pagination.total_items === 0
      )
    }
  },
  created () {
    const query = {
      page: this.$route.query.page || 1
    }
    const page = this.$route.query.page || 1
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      customerId: this.$route.params.id,
      page: page
    }
    this.$router.replace({ query: query }).catch(err => err)
    this.$store.dispatch('GET_CUSTOMER_CARDS', params)
  }
}
</script>
